import styled, { css } from 'styled-components';
import selectIcon from '../../../common/icons/select.svg';

export default styled.select`
  padding: 6px 14px;
  width: 90%;
  min-width: 80px;
  margin: 0.5rem 0;
  color: #333;
  border-radius: 3px;
  border: 1px solid #f1f1f1;
  @media (pointer: coarse) {
    font-size: 16px;
  }

  appearance: none;
  background-position: right center;
  background-image: url('${selectIcon}');
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-color: #fff;
  padding-right: 28px;

  &:not([disabled]) {
    cursor: pointer;

    &:hover {
      border: 1px solid #cccccc;
    }
  }

  &:disabled {
    opacity: 0.6;
  }

  ${(props) =>
    props.success &&
    css`
      border-color: rgba(49, 205, 102, 0.3);
    `}
`;
